import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { closestCenter, DndContext, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { resolveReorderIndices } from '../EditableTableList.utils';
export function useEditableTableListDnd(param) {
    let { rows, getRowId, isRowStatic, onReorder, disableReorder } = param;
    const mouseSensor = useSensor(MouseSensor, {
        activationConstraint: {
            distance: 5
        }
    });
    const touchSensor = useSensor(TouchSensor, {
        activationConstraint: {
            delay: 200,
            tolerance: 5
        }
    });
    const sensors = useSensors(mouseSensor, touchSensor);
    const rowIds = rows.map((row, rowIndex)=>getRowId(row, rowIndex));
    const rowIsStatic = (row, rowIndex)=>{
        var _ref;
        return (_ref = isRowStatic === null || isRowStatic === void 0 ? void 0 : isRowStatic(row, rowIndex)) !== null && _ref !== void 0 ? _ref : false;
    };
    const dragRowIds = rowIds.filter((_, rowIndex)=>!rowIsStatic(rows[rowIndex], rowIndex));
    const dragEnabled = !disableReorder && onReorder != null && dragRowIds.length > 1;
    const handleDragEnd = (event)=>{
        const indices = resolveReorderIndices(rowIds, event);
        if (indices != null) onReorder === null || onReorder === void 0 ? void 0 : onReorder(indices.fromIndex, indices.toIndex);
    };
    const withDndContext = (content)=>dragEnabled ? /*#__PURE__*/ _jsx(DndContext, {
            sensors: sensors,
            collisionDetection: closestCenter,
            onDragEnd: handleDragEnd,
            children: content
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: content
        });
    const withSortableItems = (content)=>dragEnabled ? /*#__PURE__*/ _jsx(SortableContext, {
            items: dragRowIds,
            strategy: verticalListSortingStrategy,
            children: content
        }) : content;
    return {
        dragEnabled,
        rowIds,
        rowIsStatic,
        withDndContext,
        withSortableItems
    };
}
